import React from 'react'
import { Link } from 'react-router-dom'

export default function EditButton({children}) {
  return (
    <Link to={children} title="" className="btn btn-primary"><i className="fas fa-pencil-alt"></i></Link>
  )
}
